import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ModernSidebar from '../components/layout/ModernSidebar';
import ModernHeader from '../components/layout/ModernHeader';
import DynamicDashboard from '../pages/DynamicDashboard';
import Billing from '../pages/account/Billing';
import Reports from '../pages/account/Reports';
import Settings from '../pages/account/Settings';

const AccountLayout = () => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigation = [
    { name: 'Dashboard', href: '/', icon: 'LayoutDashboard' },
    { name: 'Billing', href: '/billing', icon: 'Receipt' },
    { name: 'Reports', href: '/reports', icon: 'BarChart3' },
    { name: 'Settings', href: '/settings', icon: 'Settings' },
  ];

  return (
    <div className="h-screen flex flex-col overflow-hidden" style={{ backgroundColor: '#F5F7FB' }}>
      {/* Fixed Header */}
      <ModernHeader
        setSidebarOpen={setSidebarOpen}
        user={user}
      />

      {/* Sidebar + Content Row */}
      <div className="flex flex-1 overflow-hidden" style={{ paddingTop: '64px' }}>
        <ModernSidebar
          navigation={navigation}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          user={user}
          logout={logout}
        />

        {/* Scrollable Content Area */}
        <main className="flex-1 overflow-y-auto" style={{ paddingLeft: '0' }}>
          <div className="lg:ml-[260px] p-6 max-w-full mx-auto">
            <Routes>
            <Route path="/" element={<DynamicDashboard />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AccountLayout;
